import React from 'react'

let date = new Date()

class CopyrightFooter extends React.Component{
    render(){
        return(
            <div className="footer-login">
                <span className="copyright">&copy; {date.getFullYear()}</span> Remarkable AI | <a href="https://www.beremarkable.ai/legal/privacy-policy" rel="noopener">Privacy</a>
            </div>
        )
    }
}

export {CopyrightFooter}